import { render, staticRenderFns } from "./rpd_menu.vue?vue&type=template&id=21ceb7fb&scoped=true&"
import script from "./rpd_menu.vue?vue&type=script&lang=js&"
export * from "./rpd_menu.vue?vue&type=script&lang=js&"
import style0 from "./rpd_menu.vue?vue&type=style&index=0&id=21ceb7fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ceb7fb",
  null
  
)

export default component.exports